import React from "react";
import { useParams } from "react-router-dom";
import { Col } from "@amzn/stencil-react-components/layout";
import { CurpUploadLayout } from "./curp";
import { INEUploadLayout } from "./ine";
import { TaxIdUploadLayout } from "./taxid";
import { NSSUploadLayout } from "./nss";
import { EditINEId } from "../edit/ine-edit";
import { EditCURPId } from "../edit/curp-id-edit";
import { EditTaxId } from "../edit/tax-id-edit";
import { AttachmentType } from "../models";

export const DocumentUpload = () => {
  const { documentType, isEdit } = useParams<{
    documentType: string;
    isEdit: string;
  }>();
  return (
    <Col>
      {documentType === AttachmentType.CURP && isEdit === "false" ? (
        <CurpUploadLayout />
      ) : null}
      {documentType === AttachmentType.INE && isEdit === "false" ? (
        <INEUploadLayout />
      ) : null}
      {documentType === AttachmentType.RFC && isEdit === "false" ? (
        <TaxIdUploadLayout />
      ) : null}
      {documentType === AttachmentType.NSS && isEdit === "false" ? (
        <NSSUploadLayout />
      ) : null}
      {documentType === AttachmentType.INE && isEdit === "true" ? (
        <EditINEId />
      ) : null}
      {documentType === AttachmentType.CURP && isEdit === "true" ? (
        <EditCURPId />
      ) : null}
      {documentType === AttachmentType.RFC && isEdit === "true" ? (
        <EditTaxId />
      ) : null}
      {documentType === AttachmentType.NSS && isEdit === "true" ? (
        <NSSUploadLayout />
      ) : null}
    </Col>
  );
};
